import { SolicitationResponse } from "./solicitations.model";

// Centralizar as informações de tipo em um único objeto.
export const examTypesMap = {
  imagem: 'Exame de Imagem',
  laboratorial: 'Exame Laboratorial'
} as const;

// Deriva os tipos a partir das chaves do objeto de tipos de exames.
export type ExamTypes = keyof typeof examTypesMap;

// Cria uma lista de tipo de exames a partir das chaves do objeto tipos de exames.
export const examTypes = Object.keys(examTypesMap) as ExamTypes[];

// Gera um Map a partir do objeto.
export const examsOrdersTypesList: Map<ExamTypes, string> = new Map(
  Object.entries(examTypesMap) as [ExamTypes, string][]
);

// Interface/Model do response utilizando os tipos derivados
export interface ExamsResponse {
  exam: {
    description: string;
    myclinicId: number;
    type: ExamTypes;
  }[];
  labs: {
    description: string;
    myclinicId: number;
  }[];
}

export const examsSelectOptions = Object.entries(examTypesMap).map(([value, text]) => ({
  value,
  text
}));

export type ExamsOrdersDialogResponse = {
  examNames: string[],
  examType: ExamTypes,
  suggestWhenTakeExam: {
    start: Date | null,
    end: Date | null,
    monthYear: { text: string, value: string } | null,
  },
  location: string,
  indication: string,
  solicitationId: string,
  examResults: SolicitationResponse['examResults'],
  status: SolicitationResponse['status'],
}
